import { roundToThree } from './roundToThree';

const manualCalculationsData = {
    length: 0,
    width: 0,
    height: 0,
    floor_area: 0,
    ceiling_area: 0,
    wall_area: 0,
    perimeter: 0,
    without_opening: 0,
    volume: 0,
    door_quantity: 0,
    door_area: 0,
    door_perimeter: 0,
    door_slope_area: 0,
    door_slope_perimeter: 0,
    window_quantity: 0,
    window_area: 0,
    window_perimeter: 0,
    window_slope_area: 0,
    window_slope_perimeter: 0,
};
export const getMeasurementData = (data) => {
    let calculations = {};
    let manualCalculations = {};

    Object.keys(manualCalculationsData).forEach((key) => {
        calculations[key] = roundToThree(data[key]);
        manualCalculations[key] = roundToThree(data[key]);
    });

    calculations.id = data.id;
    calculations.comment = data.comment ? data.comment : '';
    manualCalculations.comment = data.comment ? data.comment : '';
    calculations.name = data.name;
    return { calculations, manualCalculations };
};
